import useIdleTimer from "../../hooks/useIdleTimer";

export const REFRESH_TIME_MS = 30 * 60 * 1000; // 3 hours

export function useRefreshWhenStale() {
  useIdleTimer(REFRESH_TIME_MS, () => {
    if (process.env.NODE_ENV === "production") window.location.reload();
  });
}
